import { useModal } from "@/hooks/modals/useModal";
import { useBlockRecordDetailQuery } from "./useBlockRecordDetailQuery";
import { FREEZE_APPLY_TYPE } from "@/constants";

export function useFormEditable() {
  const { props } = useModal("MATERIAL_BLOCK");
  const { flowStatus, mode, isReadOnly } = props;

  const detail = useBlockRecordDetailQuery(props.recordId);

  const isInReviewMode = mode === "inReview";

  // mode 为 inReview 表单不可编辑
  if (isInReviewMode) {
    return {
      isBlockReasonEditable: false,
      isUnblockReasonEditable: false,
    };
  }

  if (isReadOnly) {
    return {
      isBlockReasonEditable: false,
      isUnblockReasonEditable: false,
    };
  }

  if (!detail) {
    return {
      isBlockReasonEditable: true,
      isUnblockReasonEditable: false,
    };
  }

  return {
    isBlockReasonEditable:
      detail.applyType === FREEZE_APPLY_TYPE.PENDING_SUBMISSION &&
      flowStatus === "已驳回",
    isUnblockReasonEditable:
      (detail.applyType === FREEZE_APPLY_TYPE.PENDING_SUBMISSION &&
        flowStatus === "已通过") ||
      (detail.applyType === FREEZE_APPLY_TYPE.PENDING_SUBMISSION &&
        flowStatus === "已驳回"),
  };
}
